<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { getCurrentInstance, onMounted } from 'vue';

import Cart from '@/components/cart/Cart.vue';
import { i18n } from '@/shared-instance';
import { useGlobalConfigurationStore } from '@/stores/useGlobalConfigurationStore';

const globalConfigurationStore = useGlobalConfigurationStore();
const { globalConfiguration } = storeToRefs(globalConfigurationStore);

i18n.install(getCurrentInstance()!.appContext.app);

onMounted(async () => {
  if (!globalConfiguration.value?.apikey) {
    throw new Error('api-key for cart component is missing');
  }
});
</script>

<template>
  <Cart :api-key="globalConfiguration?.apikey ?? ''" />
</template>
